import { c as _c } from "react/compiler-runtime";
import type { IdDocKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type IdDocOption = {
  value: IdDocKind;
  label: string;
};
const useIdDocOptions = () => {
  const $ = _c(42);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "id_document"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = {
      value: "drivers_license",
      label: t1
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp2);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      value: "passport",
      label: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp3);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = {
      value: "passport_card",
      label: t5
    };
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp4);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = {
      value: "id_card",
      label: t7
    };
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp5);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = {
      value: "residence_document",
      label: t9
    };
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp6);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11) {
    t12 = {
      value: "permit",
      label: t11
    };
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp7);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = {
      value: "visa",
      label: t13
    };
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t(_temp8);
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = {
      value: "voter_identification",
      label: t15
    };
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t12 || $[35] !== t14 || $[36] !== t16 || $[37] !== t2 || $[38] !== t4 || $[39] !== t6 || $[40] !== t8) {
    t17 = [t2, t4, t6, t8, t10, t12, t14, t16];
    $[33] = t10;
    $[34] = t12;
    $[35] = t14;
    $[36] = t16;
    $[37] = t2;
    $[38] = t4;
    $[39] = t6;
    $[40] = t8;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  return t17;
};
export default useIdDocOptions;
function _temp($) {
  return $.drivers_license;
}
function _temp2($_0) {
  return $_0.passport;
}
function _temp3($_1) {
  return $_1.passport_card;
}
function _temp4($_2) {
  return $_2.id_card;
}
function _temp5($_3) {
  return $_3.residence_document;
}
function _temp6($_4) {
  return $_4.permit;
}
function _temp7($_5) {
  return $_5.visa;
}
function _temp8($_6) {
  return $_6.voter_identification;
}